// import { ShaderCubeChrome } from '../../Reusable/ShaderCubeChrome.js'
// import { loadGLTF } from '../../Reusable/loadGLTF.js'
// import { loadFBX } from '../../Reusable/loadFBX.js'
// import { WoozyMaterial } from '../../Reusable/WoozyMaterial.js'

import { Object3D, EventDispatcher, Vector3, PerspectiveCamera } from "three"

// import { Mixer } from "./Mixer"
// import { Moves } from "./Moves"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { makeScroller } from '../../Reusable/makeScroller'
// import { CubeCam } from '../../Reusable/CubeCam'

// let Cache = new Map()
// let provideChrome = ({ NS = 'chrome1', renderer, loop }) => {
//   if (Cache.has(NS)) {
//     return Cache.get(NS)
//   } else {
//     let newChrome = new ShaderCubeChrome({ renderer, loop, res: 32, color: new Color('#ffffff') })
//     Cache.set(NS, newChrome)
//     return newChrome
//   }
// }

// Object3D
export class CamControl extends EventDispatcher {
  constructor ({ canTune = true, bus, renderer, loop, camera, clean, scene, touchdiv, cubeCam, mode = 'full'}) {
    super()
    this.canTune = canTune
    this.mode = mode
    this.cubeCam = cubeCam
    this.renderer = renderer
    this.clean = clean
    this.bus = bus
    this.scene = scene

    // if (this.mode === 'full') {
    //   this.url = require('file-loader!./glb/swat-guy.glb')
    // } else if (this.mode === 'church') {
    //   this.url = require('file-loader!./glb/girl.glb')
    // }

    this.loop = loop
    this.gltf = false
    this.camera = camera
    this.touchdiv = touchdiv

    this.useGyro = false
    this.charReady = false
    this.moodType = 'peaceful'
    // this._viewCameraMode = 'freecam'
    // this._viewCameraMode = 'behind'
    this._viewCameraMode = 'firstperson'
    this.viewSettings = {}
    this.initConfig = {
      scale: 0.1,
      controlTargetLookAt: new Vector3(0, 0, 0 + 20),
      controlTargetPos: new Vector3(0, 0, 0)
    }

    this.extraHeight = new Vector3()

    this.charmover = new Object3D()

    // this.controlTarget = new Object3D()

    this.o3d = new Object3D()
    // this.o3d.rotation.x = -Math.PI * 0.5

    this.charmover.add(this.o3d)
    this.out = {}
    this.out.o3d = this.charmover

    // this.chroma = new ShaderCubeChrome({ renderer, loop, res: 32, color: new Color('#ffffff') })
    // this.moves = new Moves()
    this.activeLog = []
    this.mainChar = new Object3D()
    this.setupCameraSystem()
    this.setupFakeCharSkeleton()

    // this.objURL = require('file-loader!./glb/jellyfish-simple.glb')
    // loadGLTF(this.objURL)
    //   .then((gltf) => {
    //     let mat = new WoozyMaterial()
    //     mat.envMap = this.cubeCam.out.envMap
    //     this.cubeCam.add(this.o3d)
    //     gltf.scene.traverse((item) => {
    //       if (item.isMesh) {
    //         item.material = mat
    //       }
    //     })
    //     gltf.scene.scale.x = 2
    //     gltf.scene.scale.y = 2
    //     gltf.scene.scale.z = 2
    //     this.o3d.add(gltf.scene)
    //     this.mainChar = gltf.scene
    //   })

    this.charReady = true

    this.out.done = Promise.resolve()

    this.addEventListener('toggle-gyro', () => {
      this.setupGyroCam()
      bus.dispatchEvent({ type: 'renderUI', data: Math.random() })
    })

    this.addEventListener('toggle-camcorder', () => {
      if (this.viewCameraMode === 'freecam') {
        this.viewCameraMode = 'firstperson'
      } else if (this.viewCameraMode === 'firstperson') {
        this.viewCameraMode = 'freecam'
      }
      bus.dispatchEvent({ type: 'renderUI', data: Math.random() })
    })
    this.setupCMDs()
  }
  get charReady () {
    return this._charReady
  }
  set charReady (v) {
    this._charReady = v
    this.bus.dispatchEvent({ type: 'renderUI' })
  }
  get viewCameraMode () {
    return this._viewCameraMode
  }
  set viewCameraMode (v) {
    this._viewCameraMode = v
    this.resetCam()
    this.dispatchEvent({ type: 'viewCamMode', data: v })
  }
  setupCMDs () {
    document.addEventListener('keydown', function(e) {
      if (e.keyCode == 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
        e.preventDefault()
      }
    }, false)
  }
  setupGyroCam () {
    try {
      if (this.proxyCam) {
        this.useGyro = !this.useGyro
        if (this.useGyro) {
          this.viewCameraMode = 'firstperson'
        }
        return
      }
      let proxyCam = this.proxyCam = new PerspectiveCamera(75, 1, 0.01, 100000000000000)
      // proxyCam.rotation.y = this.charmover.rotation.y
      let element = this.touchdiv
      let resizer = () => {
        let rect = false
        if (element) {
          rect = element.getBoundingClientRect()
        }
        proxyCam.aspect = rect.width / rect.height
        proxyCam.updateProjectionMatrix()
      }
      resizer()
      window.addEventListener('resize', resizer)

      let DeviceOrientationControls = require('three/examples/jsm/controls/DeviceOrientationControls').DeviceOrientationControls
      let controls = new DeviceOrientationControls(proxyCam, this.touchdiv)
      this.clean(() => {
        controls.dispose()
      })
      controls.dampping = true
      let proxyLookAtTarget = new Object3D()
      proxyCam.add(proxyLookAtTarget)
      let lastProxyCanRotY = 0
      this.loop(() => {
        if (!this.useGyro) {
          return
        }

        controls.enabled = true
        controls.update()

        proxyLookAtTarget.position.z = -5

        proxyCam.updateMatrix()
        proxyCam.updateMatrixWorld()
        proxyCam.updateWorldMatrix()

        proxyLookAtTarget.updateMatrix()
        proxyLookAtTarget.updateMatrixWorld()
        proxyLookAtTarget.updateWorldMatrix()

        this.extraHeight.setFromMatrixPosition(proxyLookAtTarget.matrixWorld)

        if (lastProxyCanRotY === 0) {
          lastProxyCanRotY = proxyCam.rotation.y
          return
        }
        let diff = proxyCam.rotation.y - lastProxyCanRotY
        this.charmover.rotation.y += diff
        lastProxyCanRotY = proxyCam.rotation.y
        // this.charmover.rotation.y = proxyCam.rotation.y
      })
      this.clean(() => {
        this.useGyro = false
      })
    } catch (e) {
      console.log(e)
    }
    this.useGyro = !this.useGyro
    if (this.useGyro) {
      this.viewCameraMode = 'firstperson'
    }
  }

  async setupCameraSystem () {
    let updateO3D = (o3d) => {
      o3d.updateMatrix()
      o3d.updateMatrixWorld()
      o3d.updateWorldMatrix()
    }
    var moveForward = false
    var moveBackward = false
    var moveLeft = false
    var moveRight = false
    // var canJump = false
    var turnLeft = false
    var turnRight = false

    // let speedScale = 4

    var prevTime = performance.now()
    // var velocity = new Vector3()
    // var direction = new Vector3()

    let camPlacer = new Object3D()
    camPlacer.position.z = 10
    let camPlacerVec3 = new Vector3()

    let charPlacer = new Object3D()
    let charPlacerVec3 = new Vector3()
    // charPlacer.position.y = 0
    // charPlacer.position.z = 0

    this.charmover.add(camPlacer)
    this.charmover.add(charPlacer)

    let vscroll = makeScroller({ loop: this.loop, mounter: this.touchdiv, limit: { direction: 'vertical', canRun: true, ny: 0, y: 1 }, onMove: () => {} })
    // let vscroll = {
    //   value: 0
    // }
    var onKeyDown = (event) => {

      switch ( event.keyCode ) {
        case 38: // up
        case 87: // w
          moveForward = true;
          break;

        case 37: // left
        case 65: // a
          moveLeft = true;
          break;

        case 40: // down
        case 83: // s
          moveBackward = true;
          break;

        case 39: // right
        case 68: // d
          moveRight = true;
          break;

        case 32: // space
          // canJump = false;
          break;

        case 81: // q
          turnLeft = true
          break;

        case 69: // e
          turnRight = true
          break;

        default:
          break;
      }
    };

    var onKeyUp = (event) => {
      switch ( event.keyCode ) {
        case 38: // up
        case 87: // w
          moveForward = false;
          break;

        case 37: // left
        case 65: // a
          moveLeft = false;
          break;

        case 40: // down
        case 83: // s
          moveBackward = false;
          break;

        case 39: // right
        case 68: // d
          moveRight = false;
          break;

        case 81: // q
          turnLeft = false
          break;


        case 69: // e
          turnRight = false
          break;

          default:
            break;
      }
    };

    this.addEventListener('go-forward', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 87 })
      } else {
        onKeyUp({ keyCode: 87 })
      }
    })
    this.addEventListener('go-backward', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 83 })
      } else {
        onKeyUp({ keyCode: 83 })
      }
    })

    this.addEventListener('go-left', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 65 })
      } else {
        onKeyUp({ keyCode: 65 })
      }
    })

    this.addEventListener('go-right', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 68 })
      } else {
        onKeyUp({ keyCode: 68 })
      }
    })

    this.addEventListener('turn-left', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 81 })
      } else {
        onKeyUp({ keyCode: 81 })
      }
    })
    this.addEventListener('turn-right', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 69 })
      } else {
        onKeyUp({ keyCode: 69 })
      }
    })


    document.addEventListener( 'keydown', onKeyDown, false );
    document.addEventListener( 'keyup', onKeyUp, false );
    // raycaster = new Raycaster( new Vector3(), new Vector3( 0, - 1, 0 ), 0, 10 );

    // this.camera.position.z = 500

    let lookAtVec3 = new Vector3()
    // let lookAtLerpVec3 = new Vector3()

    let headPosition = new Vector3()
    let centerPosition = new Vector3()
    let lerperLookAt = new Vector3()
    let lerperCamPos = new Vector3()
    let targetLookAt = new Vector3()
    let targetCamPos = new Vector3()
    // let centerRelPos = new Vector3()
    let guyEyePos = new Vector3()
    // let infrontOFhead = new Vector3()
    let guyBackPos = new Vector3()
    let guyBodyPos = new Vector3()

    this.controls = new OrbitControls(this.camera, this.touchdiv)
    this.controls.enablePan = true
    this.controls.enableDamping = true
    this.controls.enableKeys = false
    this.clean(() => {
      this.controls.dispose()
    })

    let charLookAtPlaceLast = new Vector3()
    let charLookAtPlace = new Vector3()

    // this.$watch('guyHead', () => {
    //   if (this.guyHead) {
    //     this.guyHead.updateMatrix()
    //     this.guyHead.updateMatrixWorld()
    //     this.guyHead.updateWorldMatrix()
    //     charLookAtPlace.setFromMatrixPosition(this.guyHead.matrixWorld)
    //   }
    // })

    this.loop(() => {
      let lookAtGuyPart = this.guyHead
      if (lookAtGuyPart && this.charReady) {
        this.controls.update()

        lookAtGuyPart.updateMatrix()
        lookAtGuyPart.updateMatrixWorld()
        lookAtGuyPart.updateWorldMatrix()
        charLookAtPlace.setFromMatrixPosition(lookAtGuyPart.matrixWorld)

        let diff = charLookAtPlaceLast.clone().sub(charLookAtPlace).multiplyScalar(-1)
        this.controls.object.position.add(diff)

        charLookAtPlaceLast.copy(charLookAtPlace)

        this.controls.target0.lerp(charLookAtPlace, 0.5)
        this.controls.target.lerp(charLookAtPlace, 0.5)
        this.controls.saveState()
      }
    })

    // this.charmover.position.x = this.initConfig.controlTargetPos.x
    // this.charmover.position.y = this.initConfig.controlTargetPos.y
    // this.charmover.position.z = this.initConfig.controlTargetPos.z
    // this.charmover.lookAt(this.initConfig.controlTargetLookAt)

    // this.addEventListener('reset-char-cam', resetCharCam)
    let lastCamMode = this.viewCameraMode
    let resetCam = () => {
      vscroll.value = 0.0
      // setTimeout(() => {
      //   vscroll.value = 0
      // }, 1000)
      // this.controls.reset()

      if (this.viewCameraMode === 'freecam' && lastCamMode !== 'freecam') {
        updateO3D(camPlacer)
        updateO3D(charPlacer)
        camPlacerVec3.setFromMatrixPosition(camPlacer.matrixWorld)
        charPlacerVec3.setFromMatrixPosition(charPlacer.matrixWorld)
        this.camera.position.copy(camPlacerVec3)
        this.camera.lookAt(charPlacerVec3)

        this.controls.update()

        this.camera.position.y += 5
        this.camera.position.z += 50
        this.controls.update()
        this.controls.autoRotate = true
        this.controls.autoRotateSpeed = Math.PI * 2.0
        setTimeout(() => {
          this.controls.autoRotate = false
        }, 1000 * 2)
      }

      if (this.viewCameraMode === 'behind') {
        this.viewSettings.adjustX = 0
        this.viewSettings.adjustY = 0
        this.viewSettings.adjustZ = 0

        this.viewSettings.cameraExtraHeight = 0
        this.viewSettings.farest = 2000
        this.viewSettings.defaultCloseup = -1189.38

      } else if (this.viewCameraMode === 'face') {

        // this.viewSettings.adjustX = 0.00000
        // this.viewSettings.adjustY = 0.00000
        // this.viewSettings.adjustZ = 0.00000

        // this.viewSettings.cameraExtraHeight = 0.00000
        // this.viewSettings.farest = 900.00000
        // this.viewSettings.defaultCloseup = 72.77900

        this.viewSettings.adjustX = 0
        this.viewSettings.adjustY = 0
        this.viewSettings.adjustZ = 0

        this.viewSettings.cameraExtraHeight = 0
        this.viewSettings.farest = 2000
        this.viewSettings.defaultCloseup = 631.5

      } else if (this.viewCameraMode === 'chase-left') {
        this.viewSettings.adjustX = -123.7555
        this.viewSettings.adjustY = 0
        this.viewSettings.adjustZ = 0

        this.viewSettings.cameraExtraHeight = 3.982
        this.viewSettings.defaultCloseup = 138.76
        this.viewSettings.farest = 900
      } else if (this.viewCameraMode === 'chase-right') {
        this.viewSettings.adjustX = 123.7555
        this.viewSettings.adjustY = 0
        this.viewSettings.adjustZ = 0

        this.viewSettings.cameraExtraHeight = 3.982
        this.viewSettings.defaultCloseup = 138.76
        this.viewSettings.farest = 900
      } else if (this.viewCameraMode === 'front') {
        this.viewSettings.adjustX = 123.75550000000001
        this.viewSettings.adjustY = 0
        this.viewSettings.adjustZ = 0

        this.viewSettings.cameraExtraHeight = 3.9820000000000007
        this.viewSettings.farest = 900
        this.viewSettings.defaultCloseup = -138.76
      } else if (this.viewCameraMode === 'close-right') {
        this.viewSettings.adjustX = -147.9535
        this.viewSettings.adjustY = 0
        this.viewSettings.adjustZ = -195.1051

        this.viewSettings.cameraExtraHeight = 0
        this.viewSettings.defaultCloseup = 0
        this.viewSettings.farest = 900
      } else if (this.viewCameraMode === 'close-left') {
        this.viewSettings.adjustX = 147.9535
        this.viewSettings.adjustY = 0
        this.viewSettings.adjustZ = -195.1051

        this.viewSettings.cameraExtraHeight = 0
        this.viewSettings.defaultCloseup = 0
        this.viewSettings.farest = 900
      } else if (this.viewCameraMode === 'firstperson') {

        this.viewSettings.adjustX = 0
        this.viewSettings.adjustY = 33.26770000000004
        this.viewSettings.adjustZ = -10.021200000000006

        this.viewSettings.cameraExtraHeight = -64.0079999999999
        this.viewSettings.farest = 150
        this.viewSettings.defaultCloseup = 7.637000000000011

        // this.viewSettings.adjustX = 0
        // this.viewSettings.adjustY = 17.267699999999984
        // this.viewSettings.adjustZ = 1.3787999999999865

        // this.viewSettings.cameraExtraHeight = -10.008000000000013
        // this.viewSettings.farest = 50
        // this.viewSettings.defaultCloseup = -11.363000000000005

        // this.viewSettings.adjustX = 0
        // this.viewSettings.adjustY = 18.999999999999993
        // this.viewSettings.adjustZ = -29.521200000000025

        // this.viewSettings.cameraExtraHeight = 28.999999999999957
        // this.viewSettings.farest = -100
        // this.viewSettings.defaultCloseup = 4.636999999999985

        // this.viewSettings.adjustX = 0
        // this.viewSettings.adjustY = 17.267699999999984
        // this.viewSettings.adjustZ = -8.121200000000018

        // this.viewSettings.cameraExtraHeight = -10.008000000000015
        // this.viewSettings.farest = 150
        // this.viewSettings.defaultCloseup = -11.363000000000005
      } else if (this.viewCameraMode === 'firstback') {

        this.viewSettings.adjustX = 0.00000
        this.viewSettings.adjustY = 85.03870
        this.viewSettings.adjustZ = -131.77540

        this.viewSettings.cameraExtraHeight = 0.00000
        this.viewSettings.farest = 900.00000
        this.viewSettings.defaultCloseup = 0.00000

      } else if (this.viewCameraMode === 'firstface') {

        this.viewSettings.adjustX = 0.00000
        this.viewSettings.adjustY = 133.43470
        this.viewSettings.adjustZ = -76.46570

        this.viewSettings.cameraExtraHeight = -65.26500
        this.viewSettings.farest = 900.00000
        this.viewSettings.defaultCloseup = -56.35400
      } else if (this.viewCameraMode === 'freecam') {
        this.viewSettings.adjustX = 0
        this.viewSettings.adjustY = 17.267699999999984
        this.viewSettings.adjustZ = -1.5212000000000112

        this.viewSettings.cameraExtraHeight = -2.208000000000006
        this.viewSettings.farest = 920
        this.viewSettings.defaultCloseup = -23.363000000000014
      }

      this.viewSettings.adjustX *= this.initConfig.scale
      this.viewSettings.adjustY *= this.initConfig.scale
      this.viewSettings.adjustZ *= this.initConfig.scale
      this.viewSettings.cameraExtraHeight *= this.initConfig.scale
      this.viewSettings.farest *= this.initConfig.scale
      this.viewSettings.defaultCloseup *= this.initConfig.scale

      this.dispatchEvent({ type: 'reset-cam' })
      lastCamMode = this.viewCameraMode
    }

    resetCam()
    // this.camera.position.z = -50
    // this.camera.position.w = 28
    this.camera.lookAt(new Vector3(0, 0, -10))
    this.resetCam = resetCam
    // this.$watch('viewCameraMode', resetCam)

    if (this.canTune && process.env.NODE_ENV === 'development' && window.innerWidth > 500) {
      const dat = require('dat.gui')
      const gui = new dat.GUI()

      // gui.domElement.style.position = 'absolute'
      // gui.domElement.style.top = '0px'
      // gui.domElement.style.right = '0px'
      // this.element.appendChild(gui.domElement)
      this.addEventListener('reset-cam', () => {
        gui.updateDisplay()
      })
      this.clean(() => {
        gui.destroy()
      })
      gui.add(this.viewSettings, 'adjustX')
      gui.add(this.viewSettings, 'adjustY')
      gui.add(this.viewSettings, 'adjustZ')
      gui.add(this.viewSettings, 'cameraExtraHeight')
      gui.add(this.viewSettings, 'farest')
      gui.add(this.viewSettings, 'defaultCloseup')
      let copy2clip = require('copy-to-clipboard')
      let copy = () => {
        copy2clip(`
          this.viewSettings.adjustX = ${1 / this.initConfig.scale * this.viewSettings.adjustX}
          this.viewSettings.adjustY = ${1 / this.initConfig.scale * this.viewSettings.adjustY}
          this.viewSettings.adjustZ = ${1 / this.initConfig.scale * this.viewSettings.adjustZ}

          this.viewSettings.cameraExtraHeight = ${1 / this.initConfig.scale * this.viewSettings.cameraExtraHeight}
          this.viewSettings.farest = ${1 / this.initConfig.scale * this.viewSettings.farest}
          this.viewSettings.defaultCloseup = ${1 / this.initConfig.scale * this.viewSettings.defaultCloseup}
        `)
      }
      gui.add({ copy }, 'copy')
    }

    this.loop(() => {
      if (!this.charReady) { return }
      var time = performance.now()
      var delta = (time - prevTime) / 1000
      prevTime = time;

      // delta *= this.initConfig.scale

      // update control target
      if (turnLeft) {
        this.charmover.rotation.y += delta * 1.75
      }
      if (turnRight) {
        this.charmover.rotation.y -= delta * 1.75
      }
      if (!this.isTakingComplexAction) {
        if (moveForward) {
          this.mainChar.rotation.y += 0.033
          if (this.moodType === 'peaceful') {
            this.charmover.translateZ(-delta * -45 * this.initConfig.scale)
          } else {
            this.charmover.translateZ(-delta * -45 * this.initConfig.scale)
          }
        }
        if (moveBackward) {
          this.mainChar.rotation.y += 0.033
          if (this.moodType === 'peaceful') {
            this.charmover.translateZ(delta * -35 * this.initConfig.scale)
          } else {
            this.charmover.translateZ(delta * -35 * this.initConfig.scale)
          }
        }
        if (moveLeft) {
          this.mainChar.rotation.y += 0.033
          if (this.moodType === 'peaceful') {
            this.charmover.translateX(-delta * -45 * this.initConfig.scale)
          } else {
            this.charmover.translateX(-delta * -45 * this.initConfig.scale)
          }
        }
        if (moveRight) {
          this.mainChar.rotation.y += 0.033
          if (this.moodType === 'peaceful') {
            this.charmover.translateX(delta * -45 * this.initConfig.scale)
          } else {
            this.charmover.translateX(delta * -45 * this.initConfig.scale)
          }
        }
      }

      // updateO3D(this.controlTarget)
      updateO3D(camPlacer)
      updateO3D(charPlacer)
      // this.charmover.updateMatrix()
      // this.charmover.updateMatrixWorld()
      // this.charmover.updateWorldMatrix()

      // sync control target to character
      camPlacerVec3.setFromMatrixPosition(camPlacer.matrixWorld)
      charPlacerVec3.setFromMatrixPosition(charPlacer.matrixWorld)

      // this.charmover.rotation.x = this.charmover.rotation.x
      // this.charmover.rotation.y = this.charmover.rotation.y
      // this.charmover.rotation.z = this.charmover.rotation.z

      // this.charmover.position.x = charPlacerVec3.x
      // this.charmover.position.y = charPlacerVec3.y
      // this.charmover.position.z = charPlacerVec3.z

      // can calculate camera
      let config = this.viewSettings
      for (let kn in config) {
        if (typeof config[kn] === 'string') {
          // let orig = config[kn]
          let newVal = Number(config[kn])
          if (!isNaN(newVal)) {
            config[kn] = newVal
          }
        }
      }
      if (this.guyHead && this.guy && this.guyFace && this.guyBack) {
        this.guy.getWorldPosition(centerPosition)

        let flip = [
          'close-left',
          'close-right',
          'behind',
          'firstface',
          'front'
        ]
        centerPosition.x += config.adjustX
        centerPosition.y += config.adjustY

        if (flip.includes(this.viewCameraMode)) {
          centerPosition.z += config.adjustZ + config.defaultCloseup - vscroll.value * -1 * config.farest
        } else {
          centerPosition.z += config.adjustZ + config.defaultCloseup + vscroll.value * -1 * config.farest
        }

        this.guyFace.position.x = config.adjustX
        this.guyFace.position.y = config.adjustY
        if (flip.includes(this.viewCameraMode)) {
          this.guyFace.position.z = config.adjustZ + config.defaultCloseup - vscroll.value * -1 * config.farest
        } else {
          this.guyFace.position.z = config.adjustZ + config.defaultCloseup + vscroll.value * -1 * config.farest
        }

        this.guyBack.position.x = config.adjustX
        this.guyBack.position.y = config.adjustY
        if (flip.includes(this.viewCameraMode)) {
          this.guyBack.position.z = config.adjustZ + config.defaultCloseup - vscroll.value * -1 * config.farest
        } else {
          this.guyBack.position.z = config.adjustZ + config.defaultCloseup + vscroll.value * -1 * config.farest
        }

        camPlacer.position.x = config.adjustX
        camPlacer.position.y = config.adjustY - vscroll.value * -1 * config.farest * 0.4
        if (flip.includes(this.viewCameraMode)) {
          camPlacer.position.z = config.adjustZ + config.defaultCloseup - vscroll.value * -1 * config.farest
        } else {
          camPlacer.position.z = config.adjustZ + config.defaultCloseup + vscroll.value * -1 * config.farest
        }

        updateO3D(this.guyHead)
        updateO3D(this.guy)
        updateO3D(this.guyFace)
        updateO3D(this.guyBack)
        updateO3D(camPlacer)

        guyEyePos.setFromMatrixPosition(this.guyFace.matrixWorld)
        guyBackPos.setFromMatrixPosition(this.guyBack.matrixWorld)
        camPlacerVec3.setFromMatrixPosition(camPlacer.matrixWorld)

        headPosition.setFromMatrixPosition(this.guyHead.matrixWorld)
        guyBodyPos.setFromMatrixPosition(this.guy.matrixWorld)
        lookAtVec3.setFromMatrixPosition(this.guy.matrixWorld)
      }

      // let progress = vscroll.value
      // let scrollZoom = config.farest * progress * 1
      // let extraZoom = config.defaultCloseup + scrollZoom

      if (this.viewCameraMode === 'behind') {
        // make use of position
        targetCamPos.x = guyBackPos.x
        targetCamPos.y = guyBackPos.y + config.cameraExtraHeight
        targetCamPos.z = guyBackPos.z

        targetLookAt.x = guyBodyPos.x
        targetLookAt.y = guyBodyPos.y - config.cameraExtraHeight
        targetLookAt.z = guyBodyPos.z
      } else if (this.viewCameraMode === 'face') {
        // make use of position
        targetCamPos.x = guyEyePos.x
        targetCamPos.y = guyEyePos.y + config.cameraExtraHeight
        targetCamPos.z = guyEyePos.z

        targetLookAt.x = headPosition.x
        targetLookAt.y = headPosition.y - config.cameraExtraHeight
        targetLookAt.z = headPosition.z
      } else if (this.viewCameraMode === 'chase-left') {
        // make use of position
        targetCamPos.x = centerPosition.x
        targetCamPos.y = centerPosition.y + config.cameraExtraHeight
        targetCamPos.z = centerPosition.z

        targetLookAt.x = guyBodyPos.x
        targetLookAt.y = guyBodyPos.y - config.cameraExtraHeight
        targetLookAt.z = guyBodyPos.z
      } else if (this.viewCameraMode === 'chase-right') {
        // make use of position
        targetCamPos.x = centerPosition.x
        targetCamPos.y = centerPosition.y + config.cameraExtraHeight
        targetCamPos.z = centerPosition.z

        targetLookAt.x = guyBodyPos.x
        targetLookAt.y = guyBodyPos.y - config.cameraExtraHeight
        targetLookAt.z = guyBodyPos.z
      } else if (this.viewCameraMode === 'front') {
        // make use of position
        targetCamPos.x = centerPosition.x
        targetCamPos.y = centerPosition.y + config.cameraExtraHeight
        targetCamPos.z = centerPosition.z

        targetLookAt.x = guyBodyPos.x
        targetLookAt.y = guyBodyPos.y - config.cameraExtraHeight
        targetLookAt.z = guyBodyPos.z
      } else if (this.viewCameraMode === 'close-left') {
        // make use of position
        targetCamPos.x = centerPosition.x
        targetCamPos.y = centerPosition.y + config.cameraExtraHeight
        targetCamPos.z = centerPosition.z

        targetLookAt.x = guyBodyPos.x
        targetLookAt.y = guyBodyPos.y - config.cameraExtraHeight
        targetLookAt.z = guyBodyPos.z
      } else if (this.viewCameraMode === 'close-right') {
        // make use of position
        targetCamPos.x = centerPosition.x
        targetCamPos.y = centerPosition.y + config.cameraExtraHeight
        targetCamPos.z = centerPosition.z

        targetLookAt.x = guyBodyPos.x
        targetLookAt.y = guyBodyPos.y - config.cameraExtraHeight
        targetLookAt.z = guyBodyPos.z
      } else if (this.viewCameraMode === 'firstperson') {
        // // make use of position
        targetCamPos.x = camPlacerVec3.x
        targetCamPos.y = camPlacerVec3.y + config.cameraExtraHeight
        targetCamPos.z = camPlacerVec3.z

        // make use of position
        // targetCamPos.x = centerPosition.x
        // targetCamPos.y = centerPosition.y + config.cameraExtraHeight
        // targetCamPos.z = centerPosition.z

        targetLookAt.x = lookAtVec3.x
        targetLookAt.y = lookAtVec3.y - config.cameraExtraHeight
        targetLookAt.z = lookAtVec3.z
      } else if (this.viewCameraMode === 'firstback') {
        // make use of position
        targetCamPos.x = camPlacerVec3.x
        targetCamPos.y = camPlacerVec3.y + config.cameraExtraHeight
        targetCamPos.z = camPlacerVec3.z

        targetLookAt.x = lookAtVec3.x
        targetLookAt.y = lookAtVec3.y - config.cameraExtraHeight
        targetLookAt.z = lookAtVec3.z
      } else if (this.viewCameraMode === 'firstface') {
        // make use of position
        targetCamPos.x = camPlacerVec3.x
        targetCamPos.y = camPlacerVec3.y + config.cameraExtraHeight
        targetCamPos.z = camPlacerVec3.z

        targetLookAt.x = lookAtVec3.x
        targetLookAt.y = lookAtVec3.y - config.cameraExtraHeight
        targetLookAt.z = lookAtVec3.z
      }

      if (this.viewCameraMode === 'behind') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'face') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'chase-left') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'chase-right') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'front') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'close-left') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'close-right') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'firstperson') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'firstback') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      } else if (this.viewCameraMode === 'firstface') {
        lerperLookAt.lerp(targetLookAt, 0.2)
        lerperCamPos.lerp(targetCamPos, 0.2)
      }

      if (this.viewCameraMode === 'freecam') {
        this.controls.enabled = true
        this.controls.update()
      } else {
        this.controls.enabled = false
        if (this.useGyro && ['firstperson', 'firstback'].includes(this.viewCameraMode)) {
          lerperLookAt.y += this.extraHeight.y * 3 + 2
          // lerperLookAt.z += this.extraHeight.z
          // lerperLookAt.x += this.extraHeight.x
        }
        this.camera.lookAt(lerperLookAt)
        this.camera.position.copy(lerperCamPos)
      }
    })
  }

  goSet (key, val) {
    this[key] = val
  }
  setupFakeCharSkeleton () {
    let letsgo = true
    let item = new Object3D()
    if (letsgo || item && item.name === 'mixamorigSpine2') {
      let guyCenter = new Object3D()
      guyCenter.position.y = 0
      item.add(guyCenter)
      this.goSet('guy', guyCenter)
    }

    if (letsgo || item && item.name === 'mixamorigSpine') {
      let guyBack = new Object3D()
      guyBack.position.y = 0
      guyBack.position.z = 0
      item.add(guyBack)
      this.goSet('guyBack', guyBack)
    }

    if (letsgo || item && item.name === 'mixamorigNeck') {
      let guyNeck = new Object3D()
      guyNeck.position.y = 0
      guyNeck.position.z = 0
      item.add(guyNeck)
      this.goSet('guyNeck', guyNeck)
    }

    if (letsgo || item && item.name === 'mixamorigHead') {
      let guyFace = new Object3D()
      guyFace.position.x = 0
      guyFace.position.y = 0
      guyFace.position.z = 0
      item.add(guyFace)
      this.goSet('guyFace', guyFace)
    }

    if (letsgo || item && item.name === 'mixamorigHead') {
      let guyHeadCam = new Object3D()
      guyHeadCam.position.x = 0
      guyHeadCam.position.y = 0
      guyHeadCam.position.z = -10
      item.add(guyHeadCam)
      this.goSet('guyHeadCam', guyHeadCam)
    }

    if (letsgo || item && item.name === 'mixamorigHead') {
      let guyHead = new Object3D()
      guyHead.position.y = 0
      guyHead.position.z = 0
      item.add(guyHead)
      this.goSet('guyHead', guyHead)
    }

    if (letsgo || item && item.name === 'mixamorigHips') {
      let guyHip = new Object3D()
      guyHip.position.y = 0
      guyHip.position.z = 0
      item.add(guyHip)
      this.goSet('guyHip', guyHip)
    }
    // gltf.scene.traverse(async (item) => {
    //   // console.log(item.name)
    //   //
    // })

    item.position.y = 0
    item.position.z = 18
    item.position.x = 0
    this.o3d.add(item)

    return item
  }
}
